module.exports = __webpack_public_path__ + "img/zixun-2.fcc033d.png";